import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { BASE_URL } from "../../utils/urls";

export const noticeApi = createApi({
  reducerPath: "noticeApi",
  baseQuery: fetchBaseQuery({
    baseUrl: BASE_URL,
    prepareHeaders: (headers) => {
      const token = localStorage.getItem("token");
      if (token) {
        headers.set("authorization", `Bearer ${token}`);
      }
      return headers;
    },
    tagTypes: ["Notice", "Class"],
  }), // schedules
  endpoints: (builder) => ({
    getNotices: builder.query({
      query: () => ({ url: `notice`, method: "GET" }),
      providesTags: ["Notice"],
    }),
    getNoticeById: builder.query({
      query: (id) => ({ url: `notice/${id}/edit`, method: "GET" }),
    }),
    createNotice: builder.mutation({
      query: (createNotice) => ({
        url: `notice`,
        method: "POST",
        body: createNotice,
        headers: {
          "Content-type": "application/json; charset=UTF-8",
        },
      }),
      invalidatesTags: ["Notice"],
    }),
    updateNotice: builder.mutation({
      query: ({ id, ...updateNotice }) => ({
        url: `notice/${id}`,
        method: "POST",
        body: updateNotice,
        headers: {
          "Content-type": "application/json; charset=UTF-8",
        },
      }),
      invalidatesTags: ["Notice"],
    }),

    deleteNotice: builder.mutation({
      query: (id) => ({
        url: `notice/${id}`,
        method: "DELETE",
        headers: {
          "Content-type": "application/json; charset=UTF-8",
        },
      }),
      invalidatesTags: ["Notice"],
    }),
  }),
});

export const {
  useGetNoticesQuery,
  useGetNoticeByIdQuery,
  useCreateNoticeMutation,
  useUpdateNoticeMutation,
  useDeleteNoticeMutation,
} = noticeApi;
